import { render, staticRenderFns } from "./doc10.vue?vue&type=template&id=ad03d780"
import script from "./doc10.vue?vue&type=script&lang=js"
export * from "./doc10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports